<template>
  <div class="user-plugins-container">
    <!-- 搜索区域 -->
    <div class="search-bar">
      <!-- 搜索框 -->
      <el-input
          v-model="searchKeyword"
          placeholder="输入插件名称搜索"
          clearable
          style="width: 230px; margin: 0;"
          @clear="clearSearch"
          @keyup.enter="searchProducts"
      />
      <el-button
          style="width: 80px; margin-left: 10px;"
          type="primary"
          @click="searchProducts"
          :loading="searchLoading"
      >搜索</el-button>
    </div>

    <el-table
        :data="products"
        v-loading="loading"
        class="product-table"
        stripe
        style="width: 100%"
        border
        empty-text="暂无相关信息"
    >
      <el-table-column prop="productCode" label="插件编码"  align="center" />
      <el-table-column prop="name" label="插件名称"  align="center" />
      <el-table-column prop="version" label="使用版本" width="100" align="center" />

      <el-table-column prop="description" label="描述" width="280" align="center" show-overflow-tooltip />

      <el-table-column prop="productExpireTime" label="到期时间" align="center">
        <template #default="scope">
          <span :class="getExpireTimeClass(scope.row.productExpireTime)">
            {{ formatTime(scope.row.productExpireTime) }}
            {{ getExpireTimeStatus(scope.row.productExpireTime) }}
          </span>
        </template>
      </el-table-column>


      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template #default="scope">
          <div class="action-buttons">
            <el-button
                type="primary"
                size="small"
                @click="openRenewDialog(scope.row)"
                :disabled="isLoadingRenewal"
                :class="{
                  'expired-button': isExpired(scope.row.productExpireTime),
                  'active-button': !isExpired(scope.row.productExpireTime)
                }"
            >
              {{ isExpired(scope.row.productExpireTime) ? '续费' : '续费' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          :pager-count="5"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
      />
    </div>

    <!-- 续费弹窗 -->
    <el-dialog
        v-model="renewDialogVisible"
        :title="currentPlugin ? `续费 ${currentPlugin.name}` : '续费插件'"
        width="900px"
        :before-close="closeRenewDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="renew-dialog"
    >
      <div class="renew-dialog-content" v-if="currentPlugin">
        <!-- 插件基本信息 -->
        <div class="plugin-info-section">
          <div class="plugin-info-header">
            <h4>{{ currentPlugin.name }}</h4>
            <div class="current-expire">
              当前到期:
              <span :class="getExpireTimeClass(currentPlugin.productExpireTime)">
            {{ formatTime(currentPlugin.productExpireTime) }}
            {{ getExpireTimeStatus(currentPlugin.productExpireTime) }}
          </span>
            </div>
          </div>
          <div class="plugin-description">
            {{ currentPlugin.description || '暂无描述' }}
          </div>
        </div>

        <div class="renew-main-content">
          <!-- 左侧：周期选择 -->
          <div class="period-selection-section">
            <div class="section-title">
              <el-icon><Clock /></el-icon>
              <span>选择续费周期</span>
            </div>

            <!-- 一行显示的周期选择 -->
            <div class="period-horizontal-container">
              <div
                  v-for="period in renewPeriodOptions"
                  :key="period.value"
                  class="period-horizontal-option"
                  :class="{
                    'active': selectedRenewPeriod === period.value,
                    'popular': period.value === '90',
                    'premium': period.value === '365'
                  }"
                  @click="selectRenewPeriod(period.value)"
              >
                <div class="period-top-badge" v-if="period.badge">
                  {{ period.badge }}
                </div>
                <div class="period-main-content">
                  <div class="period-label">{{ period.label }}</div>
                  <div class="period-price">
                    <span class="currency">¥</span>
                    <span class="amount">{{ period.price }}</span>
                  </div>
                  <div class="period-days">{{ period.days }}天</div>
                  <div class="period-desc" v-if="period.desc">{{ period.desc }}</div>
                </div>
                <div class="period-check-mark" v-if="selectedRenewPeriod === period.value">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </div>

            <!-- 续费提示信息 -->
            <div class="renew-tips">
              <div class="tips-header">
                <el-icon><InfoFilled /></el-icon>
                <span>续费说明</span>
              </div>
              <div class="tips-content">
                <p>• 续费将从当前到期时间开始计算延长期限</p>
                <p>• 支付成功后，系统将自动更新到期时间</p>
                <p>• 支持微信支付，扫码完成支付</p>
                <p>• 如有问题，请联系客服：18925330037</p>
              </div>
            </div>
          </div>

          <!-- 右侧：支付区域 -->
          <div class="payment-section">
<!--            <div class="section-title">-->
<!--              <el-icon><CreditCard /></el-icon>-->
<!--              <span>支付信息</span>-->
<!--            </div>-->

            <!-- 支付金额 -->
            <div class="payment-amount">
              <div class="amount-label">支付金额</div>
              <div class="amount-value">
                ¥{{ renewPeriodOptions.find(p => p.value === selectedRenewPeriod)?.price || 0 }}
              </div>
            </div>

            <!-- 二维码区域 -->
            <div class="qrcode-container">
              <div class="qrcode-header">
                <el-icon>
                  <svg t="1761617723278" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4874" width="28" height="28">
                    <path d="M1024 619.52c0-143.36-138.24-256-307.2-256s-307.2 112.64-307.2 256 138.24 256 307.2 256c30.72 0 61.44-5.12 92.16-10.24l97.28 51.2-25.6-76.8c87.04-51.2 143.36-128 143.36-220.16z m-414.72-40.96c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z m209.92 0c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z" fill="#4CBF00" p-id="4875"></path>
                    <path d="M358.4 609.28c0-158.72 153.6-286.72 348.16-286.72h15.36c-40.96-133.12-179.2-235.52-353.28-235.52-204.8 0-368.64 138.24-368.64 307.2 0 107.52 66.56 204.8 168.96 256l-30.72 92.16L256 686.08c35.84 10.24 71.68 15.36 112.64 15.36h10.24c-15.36-30.72-20.48-61.44-20.48-92.16z m138.24-414.72c35.84 0 66.56 30.72 66.56 66.56s-30.72 66.56-66.56 66.56C460.8 322.56 430.08 291.84 430.08 256S460.8 194.56 496.64 194.56zM245.76 322.56c-35.84 0-61.44-30.72-61.44-66.56s30.72-66.56 66.56-66.56 61.44 30.72 61.44 66.56-30.72 66.56-66.56 66.56z" fill="#4CBF00" p-id="4876"></path>
                  </svg>
                </el-icon>
                微信扫码支付
              </div>

              <div v-if="payQrCode" class="qrcode-wrapper">
                <img :src="payQrCode" alt="微信支付二维码" class="qrcode-image" />

                <!-- 支付成功遮罩 -->
                <div v-if="paymentStatus === 'success'" class="success-overlay">
                  <div class="success-content">
                    <el-icon color="#52c41a" :size="60"><Check /></el-icon>
                    <p class="success-text">支付成功</p>
                    <p class="success-hint">插件到期时间已更新</p>
                  </div>
                </div>

                <!-- 二维码过期遮罩 -->
                <div
                    v-if="isQrCodeExpired && paymentStatus === 'pending'"
                    class="expired-overlay"
                    @click="refreshQrCode"
                >
                  <div class="expired-content">
                    <el-icon color="#f56c6c" :size="30"><Refresh /></el-icon>
                    <p class="expired-text">二维码已过期</p>
                    <p class="expired-hint">点击刷新二维码</p>
                  </div>
                </div>

                <!-- 支付中状态 -->
<!--                <div v-if="paymentStatus === 'pending'" class="pending-overlay">-->
<!--                  <el-icon class="loading-icon"><Loading /></el-icon>-->
<!--                  <p>等待支付中...</p>-->
<!--                </div>-->
              </div>

              <!-- 加载状态 -->
<!--              <div v-if="renewLoading" class="qrcode-loading">-->
<!--                <el-icon><Loading /></el-icon>-->
<!--                <span>正在生成支付二维码...</span>-->
<!--              </div>-->

              <!-- 支付状态提示 -->
              <div class="payment-status-hint" v-if="payQrCode">
                <div v-if="paymentStatus === 'pending'" class="status-pending">
                  <el-icon><Timer /></el-icon>
                  <span>支付二维码有效时间：5分钟</span>
                </div>
                <div v-if="paymentStatus === 'success'" class="status-success">
                  <el-icon><CircleCheck /></el-icon>
                  <span>支付成功！3秒后自动关闭</span>
                </div>
              </div>
            </div>

            <!-- 支付操作按钮 -->
            <div class="payment-actions">
              <el-button
                  type="primary"
                  :loading="renewLoading"
                  @click="manualCheckPayment"
                  :disabled="paymentStatus === 'success'"
              >
                <template #icon>
                  <el-icon><Refresh /></el-icon>
                </template>
                手动检查支付状态
              </el-button>

<!--              <el-button-->
<!--                  @click="generateRenewQrCode"-->
<!--                  :disabled="renewLoading"-->
<!--              >-->
<!--                <template #icon>-->
<!--                  <el-icon><RefreshRight /></el-icon>-->
<!--                </template>-->
<!--                刷新二维码-->
<!--              </el-button>-->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import request from '@/utils/request'
import QRCode from 'qrcode'

// 响应式数据
const products = ref([])
const loading = ref(false)
const searchKeyword = ref('')
const searchLoading = ref(false)

// 续费相关变量
const renewDialogVisible = ref(false)
const currentPlugin = ref(null)
const selectedRenewPeriod = ref('30') // 默认选择一个月
const renewLoading = ref(false)
const payQrCode = ref('')
const paymentStatus = ref('pending')
const renewPollInterval = ref(null)
const currentRenewOrderNo = ref('')
const isLoadingRenewal = ref(false)

const qrCodeGeneratedTime = ref(0) // 二维码生成时间戳
const isQrCodeExpired = ref(false) // 二维码是否过期
const qrCodeExpireCheckInterval = ref(null) // 过期检查定时器
const QR_CODE_EXPIRE_TIME = 5 * 60 * 1000 // 5分钟过期时间（毫秒）

// 存储插件各周期价格
const pluginPrices = ref({
  price30Days: 0,
  price90Days: 0,
  price365Days: 0
})

// 续费周期选项
const renewPeriodOptions = computed(() => {
  const prices = pluginPrices.value

  return [
    {
      label: '一个月',
      value: '30',
      days: 30,
      price: (prices.price30Days || 0).toFixed(2), // 直接使用后端返回的30天价格
      desc: '短期灵活'
    },
    {
      label: '一个季度',
      value: '90',
      days: 90,
      price: (prices.price90Days || 0).toFixed(2), // 直接使用后端返回的90天价格
      badge: '推荐',
      desc: '性价比高'
    },
    {
      label: '一年',
      value: '365',
      days: 365,
      price: (prices.price365Days || 0).toFixed(2), // 直接使用后端返回的365天价格
      badge: '超值',
      desc: '最优惠'
    }
  ]
})


// 分页相关变量
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

// 获取插件列表
const fetchProducts = async () => {
  loading.value = true
  try {
    const response = await request.get('/plugin/all/products', {
      params: {
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total
      console.log(products.value)
    } else {
      // ElMessage.error(response.message || '获取插件信息失败')
    }
  } catch (error) {
    console.error('获取插件信息失败:', error)
    // ElMessage.error('获取插件信息失败: ' + (error.message || '网络错误'))
  } finally {
    loading.value = false
  }
}

// 清空搜索
const clearSearch = () => {
  searchKeyword.value = ''
  fetchProducts()
}

// 搜索插件
const searchProducts = async () => {
  if (!searchKeyword.value.trim()) {
    fetchProducts()
    return
  }

  searchLoading.value = true
  try {
    const response = await request.get('/plugin/search/products', {
      params: {
        keyword: searchKeyword.value,
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total

      if (products.value.length === 0) {
        ElMessage.info('未找到匹配的产品')
      }
    } else {
      // ElMessage.error(response.message || '搜索插件失败')
    }
  } catch (error) {
    console.error('搜索插件失败:', error)
    // ElMessage.error('搜索插件失败: ' + (error.message || '网络错误'))
  } finally {
    searchLoading.value = false
  }
}

// 分页变化处理
const handleCurrentChange = (page) => {
  currentPage.value = page
  if (searchKeyword.value) {
    searchProducts()
  } else {
    fetchProducts()
  }
}

// 格式化时间
const formatTime = (time) => {
  if (!time) return '-'
  const date = new Date(time)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 获取到期时间状态
const getExpireTimeStatus = (expireTime) => {
  if (!expireTime) return ''

  const now = new Date()
  const expireDate = new Date(expireTime)
  const diffTime = expireDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays < 0) {
    return '(已过期)'
  } else if (diffDays <= 7) {
    return '(临期)'
  }
  return ''
}

// 获取到期时间样式类
const getExpireTimeClass = (expireTime) => {
  if (!expireTime) return ''

  const now = new Date()
  const expireDate = new Date(expireTime)
  const diffTime = expireDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays < 0) {
    return 'expired'
  } else if (diffDays <= 7) {
    return 'expiring'
  } else {
    return 'normal'
  }
}

// 检查是否已过期
const isExpired = (expireTime) => {
  if (!expireTime) return true
  const now = new Date()
  const expireDate = new Date(expireTime)
  return expireDate.getTime() < now.getTime()
}

const selectRenewPeriod = (value) => {
  selectedRenewPeriod.value = value
  onRenewPeriodChange()
}

// 根据产品编码和版本号获取产品ID
const getProductIdByCodeAndVersion = async (productCode, version) => {
  try {
    const response = await request.get('/plugin/getProductId', {
      params: {
        productCode: productCode,
        version: version
      }
    });

    if (response.code === '200') {
      console.log(response.data)
      return response.data; // 返回产品ID
    } else {
      console.error('获取产品ID失败:', response.message);
      return null;
    }
  } catch (error) {
    console.error('获取产品ID失败:', error);
    return null;
  }
};

// 打开续费弹窗
const openRenewDialog = async (plugin) => {
  // 先完全重置所有状态
  resetRenewPaymentState()

  // 先根据产品编码和版本号获取产品ID
  const productId = await getProductIdByCodeAndVersion(
      plugin.productCode,
      plugin.version
  );

  if (!productId) {
    ElMessage.error('无法获取插件ID，请稍后重试');
    return;
  }

  // 设置当前插件数据
  currentPlugin.value = {
    ...plugin,
    productId: productId // 使用获取到的ID
  };
  renewDialogVisible.value = true

  // 获取插件详情以获取基础价格
  await fetchPluginPrice(productId)

  selectedRenewPeriod.value = '30' // 默认选择一个月

  // 清除之前的支付状态（再重置一次确保干净）
  payQrCode.value = ''
  paymentStatus.value = 'pending'
  currentRenewOrderNo.value = ''

  // 延迟生成二维码，避免弹窗动画卡顿
  setTimeout(() => {
    generateRenewQrCode()
  }, 300)
}

// 获取插件价格
// const fetchPluginPrice = async (productId) => {
//   try {
//     console.log(productId)
//     const response = await request.get(`/plugin/details/${productId}`)
//     if (response.code === '200' && response.data) {
//       pluginBasePrice.value = response.data.price
//
//     } else {
//       console.error('获取插件价格失败:', response.message)
//
//     }
//   } catch (error) {
//     console.error('获取插件价格失败:', error)
//
//   }
// }
const fetchPluginPrice = async (productId) => {
  try {
    // 使用新的接口获取价格信息
    const response = await request.get(`/plugin/details-with-pricing/${productId}`)
    if (response.code === '200' && response.data) {
      pluginPrices.value = {
        price30Days: response.data.price30Days || 0,
        price90Days: response.data.price90Days || 0,
        price365Days: response.data.price365Days || 0
      }
    } else {
      console.error('获取插件价格失败:', response.message)
    }
  } catch (error) {
    console.error('获取插件价格失败:', error)
  }
}

// 重置续费支付状态
const resetRenewPaymentState = () => {
  // 清除所有定时器
  if (renewPollInterval.value) {
    clearInterval(renewPollInterval.value)
    renewPollInterval.value = null
  }

  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
    qrCodeExpireCheckInterval.value = null
  }

  // 重置支付状态
  payQrCode.value = ''
  paymentStatus.value = 'pending'
  renewLoading.value = false

  // 重置过期相关状态
  isQrCodeExpired.value = false
  qrCodeGeneratedTime.value = 0
}

// 完全重置续费弹窗状态
const resetRenewDialogState = () => {
  // 重置插件相关
  currentPlugin.value = null
  pluginPrices.value = {
    price30Days: 0,
    price90Days: 0,
    price365Days: 0
  }

  // 重置选择
  selectedRenewPeriod.value = '30'

  // 重置支付相关
  payQrCode.value = ''
  paymentStatus.value = 'pending'
  currentRenewOrderNo.value = ''
  renewLoading.value = false

  // 重置过期相关
  isQrCodeExpired.value = false
  qrCodeGeneratedTime.value = 0

  // 清除所有定时器
  if (renewPollInterval.value) {
    clearInterval(renewPollInterval.value)
    renewPollInterval.value = null
  }

  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
    qrCodeExpireCheckInterval.value = null
  }
}

// 生成续费支付二维码
const generateRenewQrCode = async () => {
  // 如果已有未支付的订单，先关闭它
  if (currentRenewOrderNo.value && paymentStatus.value === 'pending') {
    await closeRenewOrder(currentRenewOrderNo.value)
    console.log('已关闭旧订单:', currentRenewOrderNo.value)
  }

  // 如果二维码已过期，先清理旧订单状态
  if (isQrCodeExpired.value && currentRenewOrderNo.value) {
    // 确保旧订单已关闭
    await closeRenewOrder(currentRenewOrderNo.value)
  }

  // 重置所有状态，开始新的支付流程
  resetRenewPaymentState()

  // 添加验证，确保当前有插件数据
  if (!currentPlugin.value) {
    ElMessage.error('插件信息加载失败，请重试')
    return
  }

  // 确保插件价格已加载
  if (pluginPrices.value.price30Days === 0 &&
      pluginPrices.value.price90Days === 0 &&
      pluginPrices.value.price365Days === 0) {
    ElMessage.warning('正在加载插件价格，请稍候...')
    // 重新获取价格
    await fetchPluginPrice(currentPlugin.value.productId)
  }

  renewLoading.value = true
  paymentStatus.value = 'pending'
  isQrCodeExpired.value = false // 重置过期状态
  qrCodeGeneratedTime.value = Date.now() // 记录生成时间
  // 注意：这里不需要重置 currentRenewOrderNo.value，closeRenewOrder 已经处理

  try {
    const selectedPeriod = renewPeriodOptions.value.find(
        opt => opt.value === selectedRenewPeriod.value
    )

    // 验证参数
    if (!selectedPeriod) {
      ElMessage.error('请选择续费周期')
      return
    }

    const response = await request.post('/pay/createQrCode', {
      productId: currentPlugin.value.productId || currentPlugin.value.id,
      productName: currentPlugin.value.name,
      days: selectedPeriod.days,
      amount: selectedPeriod.price, // 使用价格表中的价格
      description: `续费 ${currentPlugin.value.name} ${selectedPeriod.label}使用权`,
      paymentType: 'wechat_native',
      isRenewal: true,
      originalExpireTime: currentPlugin.value.productExpireTime
    })

    if (response.code === '200' && response.data.success) {
      // 生成二维码图片
      const qrCodeDataURL = await QRCode.toDataURL(response.data.qrCodeUrl, {
        width: 220,
        margin: 2,
        color: {
          dark: '#1a1a1a',
          light: '#ffffff'
        }
      })
      payQrCode.value = qrCodeDataURL
      currentRenewOrderNo.value = response.data.outTradeNo

      // 清除旧的轮询和过期检查
      if (renewPollInterval.value) {
        clearInterval(renewPollInterval.value)
      }
      if (qrCodeExpireCheckInterval.value) {
        clearInterval(qrCodeExpireCheckInterval.value)
      }

      // 启动新的轮询
      startRenewPolling(response.data.outTradeNo)

      // 启动二维码过期检查
      startQrCodeExpireCheck()

    } else {
      // 错误处理
    }
  } catch (error) {
    console.error('生成支付二维码失败:', error)
  } finally {
    renewLoading.value = false
  }
}

// 轮询支付状态
const startRenewPolling = (outTradeNo) => {
  if (renewPollInterval.value) {
    clearInterval(renewPollInterval.value)
  }

  renewPollInterval.value = setInterval(async () => {
    try {
      const response = await request.get(`/pay/pollStatus/${outTradeNo}`)

      if (response.code === '200' && response.data.success) {
        if (response.data.paid) {
          // 支付成功
          paymentStatus.value = 'success'
          clearInterval(renewPollInterval.value)
          renewPollInterval.value = null

          // 停止过期检查
          if (qrCodeExpireCheckInterval.value) {
            clearInterval(qrCodeExpireCheckInterval.value)
            qrCodeExpireCheckInterval.value = null
          }

          ElMessage.success({
            message: '续费成功！插件到期时间已更新',
            duration: 3000
          })

          // 刷新插件列表
          setTimeout(() => {
            fetchProducts()
          }, 1000)
        }
      }
    } catch (error) {
      console.error('轮询支付状态失败:', error)
    }
  }, 3000)
}

// 续费周期改变事件
const onRenewPeriodChange = () => {
  generateRenewQrCode()
}

// 启动二维码过期检查
const startQrCodeExpireCheck = () => {
  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
  }

  qrCodeExpireCheckInterval.value = setInterval(() => {
    const now = Date.now()
    const elapsedTime = now - qrCodeGeneratedTime.value

    if (elapsedTime >= QR_CODE_EXPIRE_TIME && paymentStatus.value === 'pending') {
      // 二维码过期时执行的操作
      isQrCodeExpired.value = true
      clearInterval(qrCodeExpireCheckInterval.value)
      qrCodeExpireCheckInterval.value = null

      // 1. 停止支付状态轮询
      if (renewPollInterval.value) {
        clearInterval(renewPollInterval.value)
        renewPollInterval.value = null
      }

      // 2. 关闭当前订单
      if (currentRenewOrderNo.value) {
        closeRenewOrder(currentRenewOrderNo.value)
        ElMessage.warning('二维码已过期，订单已自动关闭，请刷新二维码重新支付')
      }
    }
  }, 1000) // 每秒检查一次
}

// 刷新二维码（过期时点击遮盖层调用）
const refreshQrCode = async () => {
  if (isQrCodeExpired.value) {
    // 先关闭旧订单（如果存在且未支付）
    if (currentRenewOrderNo.value && paymentStatus.value === 'pending') {
      await closeRenewOrder(currentRenewOrderNo.value)
    }

    // 重置过期状态
    isQrCodeExpired.value = false

    // 生成新二维码
    generateRenewQrCode()
  }
}

// 关闭续费弹窗
const closeRenewDialog = () => {
  renewDialogVisible.value = false

  // 清除所有定时器
  if (renewPollInterval.value) {
    clearInterval(renewPollInterval.value)
    renewPollInterval.value = null
  }

  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
    qrCodeExpireCheckInterval.value = null
  }

  // 关闭弹窗时清理订单
  if (currentRenewOrderNo.value && paymentStatus.value === 'pending') {
    closeRenewOrder(currentRenewOrderNo.value)
  }

  // 完全重置所有状态
  resetRenewDialogState()
  isQrCodeExpired.value = false // 重置过期状态
  qrCodeGeneratedTime.value = 0 // 重置生成时间
}

// 关闭订单
const closeRenewOrder = async (outTradeNo) => {
  if (!outTradeNo) return

  try {
    await request.post(`/pay/closeOrder/${outTradeNo}`)
  } catch (error) {
    console.error('关闭订单失败:', error)
  }
}

// 手动检查支付状态
const manualCheckPayment = async () => {
  if (!currentRenewOrderNo.value) return

  try {
    const response = await request.get(`/pay/pollStatus/${currentRenewOrderNo.value}`)
    if (response.code === '200' && response.data.success && response.data.paid) {
      paymentStatus.value = 'success'
      if (renewPollInterval.value) {
        clearInterval(renewPollInterval.value)
        renewPollInterval.value = null
      }

      ElMessage.success('支付成功！刷新列表中...')
      setTimeout(() => {
        fetchProducts()
      }, 1000)
    } else {
      ElMessage.info('支付未完成，请继续等待')
    }
  } catch (error) {
    console.error('检查支付状态失败:', error)
  }
}



onMounted(() => {
  fetchProducts()
})

// onBeforeUnmount(() => {
//   if (renewPollInterval.value) {
//     clearInterval(renewPollInterval.value)
//   }
// })

onBeforeUnmount(() => {
  if (renewPollInterval.value) {
    clearInterval(renewPollInterval.value)
  }

  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
  }
})
</script>

<style scoped>
.user-plugins-container {
  padding: 20px;
  margin: 0 auto;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: nowrap;
}

/* 表格头部样式 */
:deep(.el-table__header) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

:deep(.el-table__header th) {
  font-weight: 600;
  color: #1f2937;
  background-color: #f8fafc !important;
  font-size: 14px;
  letter-spacing: 0.025em;
}

:deep(.el-table__header .cell) {
  font-weight: 600;
  color: #374151;
}

:deep(.el-table th),
:deep(.el-table td) {
  text-align: center;
  border-bottom: 1px solid #f3f4f6;
}

/* 自定义空数据样式 */
:deep(.el-table__empty-block) {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.el-table__empty-text) {
  color: #909399;
  font-size: 14px;
  font-weight: 500;
}


/* 到期时间样式 */
.expired {
  color: #f56c6c;
  font-weight: bold;
}

.expiring {
  color: #e6a23c;
  font-weight: bold;
}

.normal {
  color: #67c23a;
  font-weight: bold;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background-color: transparent;
}

:deep(.el-pagination) {
  font-weight: normal;
  background-color: transparent;
}

/* 续费弹窗样式 */
.renew-dialog {
  :deep(.el-dialog) {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  }

  :deep(.el-dialog__header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    margin: 0;
    padding: 24px 32px;
    position: relative;
  }

  :deep(.el-dialog__title) {
    color: white;
    font-size: 20px;
    font-weight: 600;
  }

  :deep(.el-dialog__headerbtn) {
    top: 24px;
    right: 32px;

    .el-dialog__close {
      color: white;
      font-size: 20px;
    }
  }
}

.renew-dialog-content {
  padding: 0;
}

/* 插件信息区域 */
.plugin-info-section {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 10px 18px;
  border-bottom: 1px solid #e2e8f0;
}

.plugin-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
  }
}

.current-expire {
  font-size: 14px;
  color: #64748b;

  span {
    font-weight: 600;
    margin-left: 8px;
  }
}

.plugin-description {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 主要内容区域 */
.renew-main-content {
  display: flex;
  min-height: 500px;
  background: white;
}

/* 修改周期选择为一行显示 */
.period-selection-section {
  flex: 2;
  padding: 20px 32px;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;

  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;

    .el-icon {
      color: #6366f1;
      font-size: 20px;
    }
  }
}

/* 横向周期选择容器 */
.period-horizontal-container {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

/* 横向周期选项 */
.period-horizontal-option {
  flex: 1;
  position: relative;
  padding: 20px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    border-color: #6366f1;
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(99, 102, 241, 0.1);
  }

  &.active {
    border-color: #6366f1;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%);
    box-shadow: 0 10px 25px rgba(99, 102, 241, 0.15);
  }

  &.popular {
    border-color: #f59e0b;

    .period-top-badge {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    }

    &.active {
      border-color: #f59e0b;
      background: linear-gradient(135deg, rgba(245, 158, 11, 0.05) 0%, rgba(217, 119, 6, 0.05) 100%);
    }
  }

  &.premium {
    border-color: #10b981;

    .period-top-badge {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    &.active {
      border-color: #10b981;
      background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(5, 150, 105, 0.05) 100%);
    }
  }
}

/* 顶部角标 */
.period-top-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
  z-index: 1;
}

/* 主要内容 */
.period-main-content {
  .period-label {
    font-size: 14px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 8px;
  }

  .period-price {
    margin-bottom: 8px;

    .currency {
      font-size: 18px;
      font-weight: 600;
      color: #6366f1;
    }

    .amount {
      font-size: 28px;
      font-weight: 700;
      color: #6366f1;
      margin-left: 2px;
    }
  }

  .period-days {
    font-size: 13px;
    color: #94a3b8;
    margin-bottom: 4px;
  }

  .period-desc {
    font-size: 12px;
    color: #cbd5e1;
    margin-top: 4px;
  }
}

/* 选中标记 */
.period-check-mark {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-icon {
    color: white;
    font-size: 14px;
    font-weight: bold;
  }
}

.renew-tips {
  margin-top: 32px;
  padding: 20px;
  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);
  border-radius: 12px;
  border: 1px solid #c7d2fe;
}

.tip-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #475569;

  &:last-child {
    margin-bottom: 0;
  }

  .el-icon {
    flex-shrink: 0;
    margin-top: 2px;
    color: #6366f1;
  }
}

/* 右侧支付区域 */
.payment-section {
  flex: 1;
  padding: 20px 32px;
  display: flex;
  flex-direction: column;
  background: beige;
}

/* 支付金额区域 */
.payment-amount {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  padding: 20px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #bae6fd;
  margin: 0;
}

.amount-label {
  font-size: 14px;
  color: #0369a1;
  font-weight: 500;
}

.amount-value {
  font-size: 32px;
  font-weight: 700;
  color: #0284c7;
}



/* 二维码容器 - 固定高度 */
.qrcode-container {
  display: flex;
  flex-direction: column;
  flex: 1; /* 占据剩余空间 */
}

/* 二维码显示区域 - 固定高度 */
.qrcode-display-area {
  flex: 1;
  min-height: 320px; /* 固定最小高度 */
  max-height: 350px; /* 固定最大高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  position: relative;
  margin: 0;
  padding: 20px;
}

.qrcode-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 5px;
  margin-bottom: 8px;
  text-align: center;

  .el-icon {
    color: #07c160;
  }
}

/* 二维码包装器 */
.qrcode-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-image {
  width: 240px;
  height: 240px;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.qrcode-image:hover {
  transform: scale(1.02);
}

/* 遮罩层样式 */
.success-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  animation: fadeIn 0.5s ease;
}

.success-content {
  text-align: center;

  .success-text {
    font-size: 24px;
    font-weight: 700;
    color: #52c41a;
    margin: 16px 0 8px;
  }

  .success-hint {
    font-size: 14px;
    color: #64748b;
  }
}

.pending-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  .loading-icon {
    font-size: 48px;
    color: #6366f1;
    margin-bottom: 16px;
    animation: rotating 2s linear infinite;
  }

  p {
    color: #64748b;
    font-size: 16px;
  }
}

.qrcode-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  .el-icon {
    font-size: 48px;
    color: #6366f1;
    animation: rotating 2s linear infinite;
  }

  span {
    font-size: 16px;
    color: #64748b;
  }
}

/* 二维码过期遮罩 */
.expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  animation: fadeIn 0.5s ease;
  cursor: pointer;
  transition: all 0.3s ease;
}

.expired-overlay:hover {
  background: rgba(255, 255, 255, 0.98);
  transform: scale(1.01);
}

.expired-content {
  text-align: center;

  .expired-text {
    font-size: 24px;
    font-weight: 700;
    color: #f56c6c;
    margin: 16px 0 8px;
  }

  .expired-hint {
    font-size: 14px;
    color: #64748b;
  }
}

/* 支付状态提示 */
.payment-status-hint {
  padding: 16px;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;

  .el-icon {
    margin-right: 8px;
    vertical-align: middle;
  }
}

.status-pending {
  color: #f59e0b;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.status-success {
  color: #10b981;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

/* 支付操作按钮 */
.payment-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 0;
}

.payment-actions .el-button {
  min-width: 160px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* 操作按钮样式 */
.action-buttons {
  .el-button {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border: none;
    color: white;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(99, 102, 241, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

.expired-text {
  color: #f56c6c;
  font-weight: 500;
  font-size: 14px;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .renew-main-content {
    flex-direction: column;
  }

  .period-selection-section {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }

  .renew-dialog {
    :deep(.el-dialog) {
      width: 95%;
      max-width: 400px;
    }
  }
}
</style>